import { AbstractFacade, plainToInstanceWithLVS } from '@goparrot/common';
import deepmerge from 'deepmerge';
import { ReadItemBaseDto, StoreItemsExposeGroup } from '@goparrot/storeitems-sdk';
export class ItemBaseReplicaFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_GATEWAY,
                },
            },
            config,
        ]), interceptors);
    }
    async list(uniqueName) {
        return plainToInstanceWithLVS(ReadItemBaseDto, (await this.client.get(`api/v2/item-bases/${encodeURIComponent(uniqueName)}/replicas`)).data, { groups: [StoreItemsExposeGroup.READ], exposeUnsetFields: false });
    }
}
//# sourceMappingURL=ItemBaseReplicaFacade.js.map